import { PayoutPeriod } from "./types";

export const MAIN_FILTER_OPTIONS = [
  { value: PayoutPeriod.Year2024, label: "2024" }
];
